import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FiTrash2 } from 'react-icons/fi';

import Spinner from '../../Spinner';
import { ImagePreview } from '../../ImagePreview';

import styles from './ImageUpload.scss';

export function ImageUpload({
    accept,
    name,
    onChange,
    onDelete,
    preview,
    previewUrl,
    isUploading,
    innerLabel,
    removable,
    actions,
    style,
}) {
    const { t } = useTranslation('ui');
    const handleDelete = useCallback(() => onChange(null, {}), [onChange]);

    return (
        <div className={styles.root} style={style}>
            {preview || <ImagePreview url={previewUrl} />}

            <div className={styles.label}>{innerLabel}</div>

            <div className={styles.actions}>
                <div className={styles.button} style={{ pointerEvents: isUploading ? 'none' : 'auto' }}>
                    <div style={{ opacity: isUploading ? 0 : 1 }}>
                        <span>{previewUrl ? t('labels.change') : t('labels.upload')}</span>
                        <input
                            type="file"
                            className={styles.fileInput}
                            accept={accept}
                            name={name}
                            onChange={onChange}
                        />
                    </div>

                    {isUploading && (
                        <div className={styles.spinner}>
                            <Spinner color="white" size={14} />
                        </div>
                    )}
                </div>

                {actions}

                {((previewUrl && removable) || removable === 'force') && (
                    <div className={cn(styles.button, styles.remove)} onClick={onDelete || handleDelete}>
                        <FiTrash2 size={14} />
                    </div>
                )}
            </div>
        </div>
    );
}

ImageUpload.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    accept: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    previewUrl: PropTypes.string,
    isUploading: PropTypes.bool,
    innerLabel: PropTypes.string,
    preview: PropTypes.any,
    actions: PropTypes.any,
    style: PropTypes.object,
    removable: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['force'])]),
};

ImageUpload.defaultProps = {
    className: '',
    accept: 'image/png,image/x-png,image/jpeg',
    isUploading: false,
    previewUrl: null,
    innerLabel: 'Image',
    removable: false,
    preview: null,
    actions: null,
    onDelete: null,
};
